module.exports = __webpack_public_path__ + "img/medal_svip4.5a19acc.png";